<template>
  <div>
    <layout :isSuccess="true">
      <template v-slot:containerZone>
        <div class="my-4">
          <v-row class="bg-white mx-0">
            <v-col cols="12" class="text-center">
              <h1>{{ $t('bill.report_bill_payment') }}</h1>
            </v-col>
            <v-col cols="10">
              <v-row>
                <v-col cols="6">
                  <v-menu
                    v-model="menuStartDate"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :value="$helper.datelabel(formData.startDate)"
                        :placeholder="$t('date')"
                        outlined
                        dense
                        hide-details
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        :label="$t('from_date')"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="formData.startDate"
                      no-title
                      locale="th"
                      @input="menuStartDate = false"
                      :header-date-format="$helper.headerDateFormat"
                      :year-format="$helper.yearFormat"
                      :weekday-format="$helper.formatWeekday" :month-format="$helper.formatMonth"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="6">
                  <v-menu
                    v-model="menuEndDate"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :value="$helper.datelabel(formData.endDate)"
                        :placeholder="$t('date')"
                        outlined
                        dense
                        hide-details
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        :label="$t('to_date')"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="formData.endDate"
                      no-title
                      locale="th"
                      @input="menuEndDate = false"
                      :header-date-format="$helper.headerDateFormat"
                      :year-format="$helper.yearFormat"
                      :weekday-format="$helper.formatWeekday" :month-format="$helper.formatMonth"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="2" class="text-center">
              <v-btn @click="onSearch()" class="primary" block :disabled="isLoading">
                <v-icon>mdi-magnify</v-icon>
                {{ $t('search') }}
              </v-btn>
            </v-col>
            <template v-if="isFristTime">
              <v-col cols="12" class="text-center grey lighten-4 pt-10">
                <h4 class="text-gray-400">{{ $t('validate.please_select_date_and_search') }}</h4>
              </v-col>
            </template>
            <template v-if="!isFristTime">
              <v-col cols="12" class="text-center pt-5 grey lighten-4">
                <h2>
                  <b>{{ $t('date_list') }}</b> {{ $helper.datelabel(tempDate.startDate) }} -
                  {{ $helper.datelabel(tempDate.endDate) }}
                </h2>
                <div class="text-end">
                  <v-btn @click="exportExcel()" class="blue white--text" :disabled="isLoading">
                    <v-icon class="me-2">mdi-file-excel-outline</v-icon>
                    Export Excel
                  </v-btn>
                </div>
              </v-col>
              <v-col
                v-if="!isLoading"
                cols="12"
                class="px-0 pt-0 pb-4 grey lighten-4"
              >
                <v-data-table
                  v-if="dataTable && dataTable.data"
                  :headers="dataTable.headers"
                  :items="dataTable.data"
                  :items-per-page="20"
                  class="elevation-1 data-table-bill"
                  item-key="objectId"
                  v-model="selectedReceipts"
                  :show-select="isShowSelectPrintReceipt"
                  :single-select="false"
                  :no-data-text="$t('noinfo')"
                  :no-results-text="$t('no_matching_records_found')"
                >

                  <template v-slot:header.marketName="{header}">
                    <div class="text-nowrap-table text-center" style="min-width: 100px;">{{header.text}}</div>
                  </template>
                  <template v-slot:header.customerName="{header}">
                    <div class="text-nowrap-table text-center" style="min-width: 100px;">{{header.text}}</div>
                  </template>
                  <template v-slot:header.customerData="{header}"> 
                    <div class="text-nowrap-table text-center" style="min-width: 100px;">{{header.text}}</div>
                  </template>
                  <template v-slot:header.businessName="{header}">
                    <div class="text-nowrap-table text-center" style="min-width: 100px;">{{header.text}}</div>
                  </template>
                  <template v-slot:header.areasName="{header}">
                    <div class="text-nowrap-table text-center" style="min-width: 100px;">{{header.text}}</div>
                  </template>

                  <template v-slot:body.prepend>
                  <tr>
                    <td class="text-center">
                      <v-icon>mdi-filter-multiple-outline</v-icon>
                    </td>
                    <td class="ps-0">
                      <v-text-field v-model="filterData.marketName" type="text" :label="$t('market.market')" solo dense
                        hide-details />
                    </td>
                    <td class="ps-0">
                      <v-text-field v-model="filterData.ref1" type="text" label="Ref1" solo dense
                        hide-details />
                    </td>
                    <td class="ps-0">
                      <v-text-field v-model="filterData.ref2" type="text" label="Ref2" solo dense
                        hide-details />
                    </td>
                    <td class="ps-0">
                      <v-text-field v-model="filterData.customerName" type="text" :label="$t('bill.payer')" solo dense
                        hide-details />
                    </td>
                    <td class="ps-0">
                      <v-text-field v-model="filterData.customerMarketId" type="text" :label="$t('bill.customer_market_id')" solo dense
                        hide-details />
                    </td>
                    <td class="ps-0">
                      <v-text-field v-model="filterData.customerData" type="text" :label="$t('customer.title')" solo dense
                        hide-details />
                    </td>
                    <td class="ps-0">
                      <v-text-field v-model="filterData.businessName" type="text" :label="$t('bill.business_name')" solo dense
                        hide-details />
                    </td>
                    <td class="ps-0">
                      <v-text-field v-model="filterData.areasName" type="text" :label="$t('area.space')" solo dense
                        hide-details />
                    </td>
                    <td class="ps-0">
                      <v-currency-field v-model="filterData.amount" :label="$t('bill.amount')" solo dense
                        hide-details />
                    </td>
                    <td class="ps-0">
                      <v-text-field v-model="filterData.documentId" type="text" :label="$t('bill.document_id')" solo dense
                        hide-details />
                    </td>
                    <td class="ps-0">
                      <v-select v-model="filterData.status" :items="filterOption.status" type="text"
                      :label="$t('bill.status')" solo dense hide-details clearable :no-data-text="$t('noinfo')"/>
                    </td>
                    <td class="ps-0">
                      <v-text-field v-model="filterData.updatedReceiptId" type="text" :label="$t('bill.receipt_id')" solo dense
                        hide-details />
                    </td>
                  </tr>
                </template>
                  <template v-slot:item.data-table-select="{ isSelected, select, item }">
                    <template v-if="isShowSelectPrintReceipt && item.isPaid">
                      <v-simple-checkbox
                        color="primary"
                        :value="isSelected"
                        @input="select($event)"
                      ></v-simple-checkbox>
                    </template>
                  </template>

                  <template v-slot:item.marketName="{ item }">
                    <div class="text-truncate text-center area-name">{{ item.marketName }}</div>
                  </template>
                  <template v-slot:item.customerName="{ item }">
                    <div class="text-truncate text-center area-name">{{ item.customerName }}</div>
                  </template>
                  <template v-slot:item.customerData="{ item }">
                    <div class="text-truncate text-center area-name">{{ item.customerData }}</div>
                  </template>
                  <template v-slot:item.businessName="{ item }">
                    <div class="text-truncate text-center area-name">{{ item.businessName }}</div>
                  </template>
                  <template v-slot:item.areasName="{ item }">
                    <div class="text-truncate text-center area-name">{{ item.areasName }}</div>
                  </template>

                  <template v-slot:item.paymentTimeStamp="{ item }">
                    <template v-if="item.paymentTimeStamp">
                      {{ $moment(item.paymentTimeStamp).format("DD/MM/YYYY") }} <br />
                      {{ $moment(item.paymentTimeStamp).format("H:mm:ss") }}
                    </template>
                  </template>

                  <template v-slot:item.createdAt="{ item }">
                    <template v-if="item.createdAt">
                      {{ $moment(item.createdAt).format("DD/MM/YYYY") }} <br />
                      {{ $moment(item.createdAt).format("H:mm:ss") }}
                    </template>
                  </template>

                  <template v-slot:item.status="{ item }" class="text-center">
                    <template v-if="item.status == $t('bill.confirmed_payment')">
                      <v-chip
                        class="green--text"
                        color="rgb(209,242,225)"
                      >
                        {{ item.status }}
                      </v-chip>
                    </template>
                    <template v-else>
                      <v-chip
                        class="red--text"
                        color="rgb(248,218,218)"
                      >
                        {{ item.status }}
                      </v-chip>
                    </template>
                  </template>

                  <template v-slot:item.amount="{ item }">
                    {{ item.amount | currency }}
                  </template>

                  <template v-slot:item.documentId="{ item }">
                    <template v-if="item.documentId">
                      <a v-if="item.invoice" @click="modalInvoiceDialog(item.invoice)" class="underline">
                        {{ item.documentId }}
                      </a>
                      <a v-else-if="item.contractCheckout" @click="modalContractCheckoutDialog(item.contractCheckout)" class="underline">
                        {{ item.documentId }}
                      </a>
                    </template>
                  </template>

                </v-data-table>
              </v-col>
              <v-col v-else>
                <v-card class="d-flex justify-center py-10">
                  <v-progress-circular
                    indeterminate
                    size="64"
                    color="green"
                  ></v-progress-circular>
                </v-card>
              </v-col>
            </template>
          </v-row>
        </div>
      </template>
    </layout>
    <v-snackbar v-model="isError" color="error" top>
      <v-icon left size="18">mdi-information</v-icon>{{ $t('error') }}
    </v-snackbar>
    <InvoiceDialog
      v-model="isInvoiceDialog"
      :invoiceId="tempInvoiceId"
      :projectId="projectId"
    />
    <CheckoutPayment
      v-model="isContractCheckoutDialog"
      :objectId="tempContractCheckoutId"
      :isDisable="true"
    />
  </div>
</template>

<script>
import InvoiceDialog from "@/components/InvoiceDialog.component";
import SelectMonthYear from "@/components/SelectMonthYear.component";
import ParentBar from "@/components/ParentBar.vue";
import Layout from "@/components/Layout.vue";
import { mapState } from "vuex";
import ReceiptDialog from "@/components/ReceiptDialog.component.vue";
import PrintDialog from "@/components/PrintDialog.component.vue";
import { ExportBillPayment } from "@/exports";
import CheckoutPayment from "@/components/CheckoutPayment.vue";
import { BillPaymentReport } from "../../classes"

export default {
  computed: {
    ...mapState({
      billPaymentReports: (state) => state.billPaymentReport.billPaymentReports,
    }),
    billPaymentReportData() {
      return this.billPaymentReports.map(billPaymentReport => {
        let obj = {};
        let businessName = '-';
        obj.paymentTimeStamp = billPaymentReport.paymentTimeStamp || ""
        obj.ref1 = billPaymentReport.ref1 || ""
        obj.ref2 = billPaymentReport.ref2 || ""
        obj.customerName = billPaymentReport.customerName || ""
        obj.amount = billPaymentReport.amount || 0
        obj.updatedReceiptId = billPaymentReport.updatedReceiptId || "-"
        obj.createdAt = billPaymentReport.createdAt || ""
        obj.functionCode = billPaymentReport.functionCode
        obj.marketName = billPaymentReport.market.name || ""

        if(billPaymentReport.contractCheckout && billPaymentReport.contractCheckout.contract.businessName){
          businessName = billPaymentReport.contractCheckout.contract.businessName
        }else if(billPaymentReport.invoice ){
          if(billPaymentReport.invoice.contract) {
            businessName = billPaymentReport.invoice.contract.businessName
          } else if(billPaymentReport.invoice.booking){
            businessName = billPaymentReport.invoice.booking.businessName
          }
        }
        obj.businessName = businessName

        if(billPaymentReport.isReceiptPaid){
          obj.status = this.$t('bill.confirmed_payment')
        }else{
          if(billPaymentReport.amountMismatch){
            obj.status = this.$t('bill.amount_mismatch')
          }else if(billPaymentReport.invoiceWasPaid){
            obj.status = this.$t('bill.invoice_was_paid')
          }else if(billPaymentReport.invoiceNotSent){
            obj.status = this.$t('bill.invoice_in_maintaining')
          }else if(billPaymentReport.invoiceNotFound){
            obj.status = this.$t('bill.invoice_not_found')
          }
        }

        if(obj.functionCode == "00"){
          let invoice = billPaymentReport.invoice
          if(invoice){
            obj.customerData = invoice.customerData ? invoice.customerData.name : "-"
            obj.customerMarketId = invoice.contract ? (invoice.contract.customerMarketId || "-") : "-"
            obj.areasName = this.getAreaName(invoice.items) || "-"
            obj.documentId = invoice.documentId || "-"
            obj.invoice = invoice
          }
        } else if(obj.functionCode == "01") {
          let contractCheckout = billPaymentReport.contractCheckout
          if(contractCheckout){
            obj.customerData = contractCheckout.customerData ? contractCheckout.customerData.name : "-"
            obj.customerMarketId = contractCheckout.contract ? (contractCheckout.contract.customerMarketId || "-") : "-"
            obj.areasName = contractCheckout.areas.map(d => d.name).join(",") || "-"
            obj.documentId = contractCheckout.documentId || "-"
            obj.contractCheckout = contractCheckout
          }
        }

        return obj
      })
    },
    dataTable() {
      return {
        headers: [
          
          {
            text: this.$t('bill.payment_date'),
            value: "paymentTimeStamp",
            align: "center",
          },
          {
            text: this.$t('market.market'),
            value: "marketName",
            width: '1%',
            class: 'custom-sort',
            align: 'center hd-resize',
            filter: d =>
              this.filterData.marketName
              ? d
                .toLowerCase()
                .includes(this.filterData.marketName.toLowerCase())
              : true
          },
          {
            text: "Ref1",
            value: "ref1",
            filter: d =>
              this.filterData.ref1
              ? d
                .toString()
                .toLowerCase()
                .includes(this.filterData.ref1.toLowerCase())
              : true
          },
          {
            text: "Ref2",
            value: "ref2",
            filter: d =>
              this.filterData.ref2
              ? d
                .toString()
                .toLowerCase()
                .includes(this.filterData.ref2.toLowerCase())
              : true
          },
          {
            text: this.$t('bill.payer'),
            value: "customerName",
            width: '1%',
            class: 'custom-sort',
            align: 'center hd-resize',
            filter: d =>
              this.filterData.customerName
              ? d
                .toLowerCase()
                .includes(this.filterData.customerName.toLowerCase())
              : true
          },
          {
            text: this.$t('bill.customer_market_id'),
            value: "customerMarketId",
            width: '1%',
            filter: d =>
              this.filterData.customerMarketId
              ? d
                .toLowerCase()
                .includes(this.filterData.customerMarketId.toLowerCase())
              : true
          },
          {
            text: this.$t('customer.title'),
            value: "customerData",
            width: '1%',
            class: 'custom-sort',
            align: 'center hd-resize',
            filter: d =>
              this.filterData.customerData
              ? d
                .toLowerCase()
                .includes(this.filterData.customerData.toLowerCase())
              : true
          },
          {
            text: this.$t('bill.business_name'),
            value: "businessName",
            width: '1%',
            class: 'custom-sort',
            align: 'center hd-resize',
            filter: d =>
              this.filterData.businessName
              ? d
                .toLowerCase()
                .includes(this.filterData.businessName.toLowerCase())
              : true
          },
          {
            text: this.$t('area.space'),
            value: "areasName",
            width: '1%',
            class: 'custom-sort',
            align: 'center hd-resize',
            filter: d =>
              this.filterData.areasName
              ? d
                .toLowerCase()
                .includes(this.filterData.areasName.toLowerCase())
              : true
          },
          {
            text: this.$t('bill.amount'),
            value: "amount",
            align: "right",
            filter: d =>
              this.filterData.amount
              ? d.toString().includes(this.filterData.amount)
              : true
          },
          {
            text: this.$t('bill.document_id'),
            value: "documentId",
            filter: d =>
              this.filterData.documentId
              ? d
                .toLowerCase()
                .includes(this.filterData.documentId.toLowerCase())
              : true
          },
          {
            text: this.$t('bill.status'),
            value: "status",
            align: "center",
            filter: d =>
              this.filterData.status ? d == this.filterData.status : d
          },
          {
            text: this.$t('bill.receipt_id'),
            value: "updatedReceiptId",
            filter: d =>
            this.filterData.updatedReceiptId
            ? d
              .toLowerCase()
              .includes(this.filterData.updatedReceiptId.toLowerCase())
            : true
          },
        ],
        data: this.billPaymentReportData,
      };
    },
  },
  data() {
    return {
      projectId: this.$route.params.projectId,
      market: null,
      selectedMonthYear: null,
      isError: false,
      isLoading: false,
      isInvoiceDialog: false,
      tempInvoiceId: null,
      menuStartDate: false,
      menuEndDate: false,
      isFristTime: true,
      formData: {
        startDate: this.$moment({day: 1}).format("YYYY-MM-DD"),
        endDate: this.$moment().endOf("month").format("YYYY-MM-DD"),
      },
      filterData: {
        marketName: null,
        ref1: null,
        ref2: null,
        customerName: null,
        customerData: null,
        businessName: null,
        areasName: null,
        amount: null,
        documentId: null,
        status: null,
        updatedReceiptId: null,
        createdAt: null,
        customerMarketId: null
      },
      filterOption: { 
        status: [
          { text: this.$t('bill.confirmed_payment')},
          { text: this.$t('bill.amount_mismatch')},
          { text: this.$t('bill.invoice_was_paid')},
          { text: this.$t('bill.invoice_in_maintaining')},
          { text: this.$t('bill.invoice_not_found')}
        ]
      },
      tempDate: null,
      tempReceipt: null,
      isShowSelectPrintReceipt: false,
      selectedReceipts: [],
      isContractCheckoutDialog: false,
      tempContractCheckoutId: null
    };
  },
  components: {
    InvoiceDialog,
    SelectMonthYear,
    ParentBar,
    Layout,
    ReceiptDialog,
    PrintDialog,
    CheckoutPayment,
  },
  methods: {
    async initData() {
      try {
        this.isFristTime = false
        this.tempDate = JSON.parse(JSON.stringify(this.formData));
        let params = {
          projectId: this.projectId,
          startDate: this.$moment(this.formData.startDate).startOf("day").toISOString(),
          endDate: this.$moment(this.formData.endDate).endOf("day").toISOString(),
        }
        let billPaymentReports = await this.$helper.queryMore(BillPaymentReport.getBillPaymentReportBetweenDateByProject, params)
        this.$store.commit("billPaymentReport/setBillPaymentReports", billPaymentReports)
      } catch (error) {
        throw error;
      }
    },
    async onSearch() {
      this.isLoading = true;
      try {
        await this.initData();
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        this.isError = true;
      }
    },
    async onSaveSuccess() {
      this.isLoading = true;
      try {
        await this.initData();
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        this.isError = true;
      }
    },
    rowClick(receipt) {
      this.tempReceipt = receipt
      this.isReceiptDialog = true;
    },
    choosePrintReceipt() {
      this.selectedReceipts = [];
      this.isShowSelectPrintReceipt = true;
    },
    getAreaName(items) {
      let name = [];
      for (let item of items) {
        if (item.area) {
          name.push(item.area.name);
        }
      }
      return [...new Set(name)].join(",") || "-";
    },
    async exportExcel() {
      this.isLoading = true 
      try{
        await ExportBillPayment.exportBillpaymentReportByProject(this.billPaymentReportData, this.formData.startDate, this.formData.endDate)
        this.isLoading = false
      }catch(error){
        this.isError = true
        this.isLoading = false
      }
    },
    modalInvoiceDialog(invoice){
      this.tempInvoiceId = invoice.objectId
      this.isInvoiceDialog = true
    },
    modalContractCheckoutDialog(contractCheckout){
      this.tempContractCheckoutId = contractCheckout.objectId
      this.isContractCheckoutDialog = true
    }
  },
};
</script>

<style lang="scss" scoped>
.data-table-bill::v-deep td.hd-resize {
  max-width: 100px;
}

.data-table-bill::v-deep th.custom-sort {
  position: relative;
  .v-icon{
    position: absolute;
    right: 24px;
    top: 18px;
  }
}
</style>